'use strict';

function defaultConstructInstance (type, data) {
  return new type(...data);
}

/**
 * Custom data classes are usually meant to be instantiated with
 * regular values and ideally should not need be aware of references
 * and embedded values and so forth.  Thus it is not possible to
 * store such values as fully instantiated (as `ResolvedValues`).
 *
 * Constructible container objects solve this problem because they
 * are essentially just instructions for how to instantiate an object
 * with some given custom type, rather than the instance itself.
 *
 * They are also treated as generic iterables by the storage code
 * for easy processing in and out of the store.
 *
 * You will need to construct these objects inside `mapResponse`. Do
 * not instantiate them directly - the embedded() helper will implicitly
 * instantiate containers for DataReferences with type BasicData, or you can
 * use the `container()` helper to explicitly create a container.
 */
module.exports = class ConstructableContainer {
  constructor (type, data, constructInstance = defaultConstructInstance) {
    if (typeof type !== 'function') {
      throw new TypeError('Invalid type given to ConstructableContainer');
    }
    this.type = type;
    this.data = data;
    this.constructInstance = constructInstance;
  }
};

module.exports.defaultConstructInstance = defaultConstructInstance;



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/storage/ConstructableContainer.js